/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { delay, HttpResponseCodes, TimeUnitsInMs, MiddlewareSteps } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

const { TooManyRequests } = HttpResponseCodes;

export const handleTooManyRequestsErrorMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { config } = ctx;
    const { response } = res;
    const { ok, status } = response;

    if (!ok && status === TooManyRequests) {
        const retryAfterHeaderStr: string | null = response.headers.get(config.getRetryAfterHeaderName());
        const parsedRetryAfterInSec: number | typeof NaN = retryAfterHeaderStr
            ? Number.parseInt(retryAfterHeaderStr, 10)
            : config.getBasicDelayFor429InSec();
        const retryAfterInSec: number = Number.isNaN(parsedRetryAfterInSec) ? config.getBasicDelayFor429InSec() : parsedRetryAfterInSec;
        const totalTime = retryAfterInSec + 1;

        delay(totalTime * TimeUnitsInMs.Second)
            .then(() => {
                // @TODO Handle case when signal became aborted
                req.rerunConfig.setStep(MiddlewareSteps.Run);
                next(res);
            });
    } else {
        next();
    }
};
